import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AddVersion, AddVersionErrors } from '@core/models/add-version';
import { Version } from '@core/objects/version';

import * as fromAddVersionState from '@app/store/state/add-version/add-version.state';
import * as fromAddVersionActions from '@app/store/state/add-version/add-version.actions';


@Injectable({
    providedIn: 'root'
})
export class AddVersionService {

    constructor(private store: Store<fromAddVersionState.AddVersionState>) {}

    // addVersion$(data: AddVersion, prefixUrl: string = "") {
    //     return this.http
    //     .post(this.url.build(prefixUrl+"/versions"),data);
    // }

    submitAddVersion(project: number, data: AddVersion) {
        this.store.dispatch(new fromAddVersionActions.SubmitAddVersion(project, data));
    }

    selectErrors(): Observable<AddVersionErrors> {
        return this.store.select(fromAddVersionState.addVersionErrorsSelector);
    }

    selectCreatingNewVersion(): Observable<boolean> {
        return this.store.select(fromAddVersionState.creatingNewVersionSelector);
    }

    selectSavedVersion(): Observable<Version | null> {
        return this.store.select(fromAddVersionState.savedVersionSelector);
    }

    clear() {
        this.store.dispatch(new fromAddVersionActions.Clear());
    }

}